import { render, staticRenderFns } from "./g2w-link-form.vue?vue&type=template&id=535cd45b&"
import script from "./g2w-link-form.vue?vue&type=script&lang=js&"
export * from "./g2w-link-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "g2w-link-form.vue"
export default component.exports